module.exports = __webpack_public_path__ + "static/media/fs-tab.74479d32.png";